import { AnimationControls } from "framer-motion";
import { GuardVariantNames } from "./variants";

export const runGuardAnimation = async (guardControl: AnimationControls, guardVariantName: GuardVariantNames) => guardControl.start(guardVariantName);
export const resetGuardAnimation = (guardControl: AnimationControls) => guardControl.set(GuardVariantNames.SNEAK_HIDDEN);